import { Platform } from "react-native";

export const mobileMaxWidth = 400;
export const isServer =
  Platform.OS === "web" && typeof location === "undefined";
